module.exports = __webpack_public_path__ + "94a1d066790dde65161d5eaa0bec9c17.png";